<template>
  <v-list
    :opened="openedGroups"
    nav
    density="compact"
    bg-color="transparent"
    @update:opened="handleOpenedUpdate"
  >
    <div v-for="(item, index) in menu" :key="index">
      <div v-if="item.text && !rail" class="pa-1 mt-2 text-overline">
        <p style="margin-top: -1.45rem;">
          {{ item.text }}
        </p>
      </div>
      <flowy-nav-menu
        :menu="item.items"
        :rail="rail"
        :index="index"
        @toggle-rail="$emit('toggle-rail')"
      />
    </div>
    <v-list-item
      active-class="text-primary"
      link
      @click="openDocs()"
    >
      <template #prepend>
        <v-icon :class="menuTextColor">
          mdi-clipboard-outline
        </v-icon>
      </template>
      <v-list-item-title :class="menuTextColor">
        {{ $t('labels.docs') }}
      </v-list-item-title>
    </v-list-item>
  </v-list>
</template>

<script>
import FlowyNavMenu from './FlowyNavMenu'
import { useTheme } from 'vuetify'
import { bus } from '@/main'

export default {
  components: {
    FlowyNavMenu
  },
  props: {
    rail: {
      type: Boolean
    },
    menu: {
      type: Array,
      default: () => []
    }
  },
  emits: ['toggle-rail'],
  data() {
    return {
      docs: 'https://getflowy.io/docs',
      openedGroups: [],
      // Flag to block auto-expand during route transitions
      blockAutoExpand: false,
      // Safety timeout handle for clearing blockAutoExpand flag
      blockAutoExpandTimeout: null
    }
  },
  computed: {
    isThemeDark() {
      const theme = useTheme()
      return theme.global.name.value === 'dark'
    },
    menuTextColor() {
      return {
        'custom-nav-color': !this.isThemeDark,
        'text-white': this.isThemeDark
      }
    }
  },
  watch: {
    '$route'() {
      // Clear the block flag after route change completes
      // Use setTimeout to ensure Vuetify's auto-expand has fired first
      if (this.blockAutoExpand) {
        setTimeout(() => {
          this.blockAutoExpand = false
        }, 50)
      }
    }
  },
  mounted() {
    bus.$on('favoriteNavigation', this.handleFavoriteNavigation)
  },
  beforeUnmount() {
    bus.$off('favoriteNavigation', this.handleFavoriteNavigation)
    if (this.blockAutoExpandTimeout) {
      clearTimeout(this.blockAutoExpandTimeout)
    }
  },
  methods: {
    // Handle favorite navigation signal from FavoritesSection
    handleFavoriteNavigation() {
      // Clear any existing timeout
      if (this.blockAutoExpandTimeout) {
        clearTimeout(this.blockAutoExpandTimeout)
      }

      this.blockAutoExpand = true
      this.openedGroups = []

      // Safety timeout: clear flag even if route change doesn't happen
      // (e.g., navigation guard cancels, same route clicked twice)
      this.blockAutoExpandTimeout = setTimeout(() => {
        this.blockAutoExpand = false
        this.blockAutoExpandTimeout = null
      }, 500)
    },
    openDocs() {
      window.open(this.docs, '_blank')
    },
    // Handle opened state updates from v-list
    // Using one-way binding (:opened) instead of v-model prevents Vuetify's
    // automatic route-based expansion from immediately affecting the DOM.
    // We selectively accept updates based on the blockAutoExpand flag.
    handleOpenedUpdate(newOpenedGroups) {
      // During favorite navigation, block auto-expand attempts
      if (this.blockAutoExpand) {
        return
      }
      this.openedGroups = newOpenedGroups
    }
  }
}
</script>
<style>

</style>
